// import swal from 'sweetalert2'
import Vue from 'vue'
// import $ from 'jquery'
const PGStorage = new Vue({
  data() {
    return {
      alreadyAddAnkerBankIntoPeergroup: false,
      maskData: {},
      events: {},
      userId: '989',
      configName: '',
      hostDownload: '',
      wzCodeData: [],
      sourceList: null,
      appConfig: {},
      configuration: null,
      name: 'Storage',
      hasAnkerBank: false,
      ratingKunde: null,
      rating: null,
      ankerBank: null,
      ankerBankBalance: [],
      ankerBankBalanceData: {},
      peergroupData: [],
      peergroupDataRows: [],
      branchList: null,
      regionList: null,
      countryList: null,
      currencyList: [],
      rechtskreise: null,
      abschlussartList: null,
      selectedCurrency: 2,
      selectedCurrencyDimension: 2,
      currencyDimensionList: [],
      groupData: [] /* Hier werden die Banken für die Peergroup gesammelt. */
    }
  },
  methods: {
    setDimension(selectedCurrency, selectedCurrencyDimension) {
      this.selectedCurrency = selectedCurrency
      this.selectedCurrencyDimension = selectedCurrencyDimension
    },
    getCurrency() {
      return this.selectedCurrency
    },
    resetCurrencyAndDimension() {
      this.selectedCurrency = 2
      this.selectedCurrencyDimension = 2
    },
    getCurrencyDimension() {
      return this.selectedCurrencyDimension
    },
    setConfigName(name, cn) {
      this.configName = cn
      console.log('setConfigName', name, this.configName)
      return this.saveState('myConfigRowName_' + name, this.configName)

    },
    getConfigName(name) {
      console.log('getConfigName', name, this.configName)
      return this.getState('myConfigRowName_' + name, this.configName)
    },
    setAnkerbank(idModule, balance) {
      Vue.prototype.storage.ankerBankBalance[idModule] = JSON.parse(JSON.stringify(balance))
    },
    getAnkerbank(idModule) {
      return Vue.prototype.storage.ankerBankBalance[idModule]
    },
    setAnkerbankData(idModule, data) {
      Vue.prototype.storage.ankerBankBalanceData[idModule] = JSON.parse(JSON.stringify(data))
      console.log('ankerBankBalanceData', this.ankerBankBalanceData[idModule])
    },
    getAnkerbankData(idModule) {
      let d = {}
      try {
        d = Vue.prototype.storage.ankerBankBalanceData[idModule]
      } catch (e) {

      }
      console.log('getAnkerbankData', d)
      return d
    },
    resetAnkerbank(idModule) {
      // console.log('resetAnkerbank', Vue.prototype.storage.ankerBankBalance[idModule])
      this.resetCurrencyAndDimension()
      this.ankerBankBalance[idModule] = null
      this.ankerBankBalanceData[idModule] = null
      this.ankerBank = null
      this.alreadyAddAnkerBankIntoPeergroup = false
    },
    isAnkerbank(idModule) {
      var res = Vue.prototype.storage.getAnkerbank(idModule)
      var data = Vue.prototype.storage.getAnkerbankData(idModule)
      if (!data) {
        console.log('missing ankerbank data')
      }
      if (res) return true
      return false
    },
    setPeergroup(idModule, bArray) {
      Vue.prototype.storage.peergroupData[idModule] = bArray
    },
    addToPeergroup(idModule, itemBalance, itemRow) {
      if (!idModule) {
        idModule = Vue.prototype.$api.getModuleId()
      }
      var pg = Vue.prototype.storage.peergroupData[idModule]
      if (pg === null || !pg) {
        Vue.prototype.storage.peergroupData[idModule] = []
        Vue.prototype.storage.peergroupDataRows[idModule] = []
      }
      Vue.prototype.storage.peergroupData[idModule].push(itemBalance)
      if (itemRow) {
        const k = Vue.prototype.$api.balanceToString(itemBalance)
        Vue.prototype.storage.peergroupDataRows[idModule][k] = itemRow
      }
    },
    isInPeergroup(item) {
      let aString = Vue.prototype.$api.balanceToString(item)
      var pgList = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())
      var idx = _.findIndex(pgList, function (storageItem) {
        var bString = Vue.prototype.$api.balanceToString(storageItem)
        return (aString === bString)
      })
      return idx > -1
    },
    getPeergroupDataRowOfBalance(itemBalance) {
      var idModule = Vue.prototype.$api.getModuleId()
      var res = null
      if (Vue.prototype.storage.peergroupDataRows[idModule]) {
        res = Vue.prototype.storage.peergroupDataRows[idModule][Vue.prototype.$api.balanceToString(itemBalance)]
      }
      return res
    },
    deleteFromPeergroup(idModule, itemToDelete) {
      var index = -1
      for (var index2 in Vue.prototype.storage.peergroupData[idModule]) {
        var item2 = Vue.prototype.storage.peergroupData[idModule][index2]
        if (Vue.prototype.$api.compareBalance(item2, itemToDelete)) {
          index = index2
          break
        }
      }
      if (index > -1) {
        Vue.prototype.storage.peergroupData[idModule].splice(index, 1)
      }

    },
    getPeergroup(idModule) {
      return Vue.prototype.storage.peergroupData[idModule]
    },
    resetPeergroup(idModule) {
      this.resetCurrencyAndDimension()
      Vue.prototype.storage.peergroupData[idModule] = null
      Vue.prototype.storage.peergroupDataRows[idModule] = null
      this.alreadyAddAnkerBankIntoPeergroup = false
    },
    isPeergroup(idModule) {
      var bArray = Vue.prototype.storage.peergroupData[idModule]
      if (bArray && bArray.length > 0) {
        return true
      }
      return false
    },
    getConfiguration() {
      return this.configuration
    },
    setWZCode(data) {
      this.wzCodeData = data
    },
    setWZCodeGroups(data) {
      this.wzCodeGroups = data
    },
    getWZCodeGroups() {
      return this.wzCodeGroups
    },
    getWZCodeData() {
      return this.wzCodeData
    },
    getUserId() {
      if (Vue.prototype.$api.getCredentials()) {
        if (Vue.prototype.$api.getCredentials().data && Vue.prototype.$api.getCredentials().data.user) {
          return Vue.prototype.$api.getCredentials().data.user.userNr
        }
      }
      return this.userId
    },
    init(data) {
      Vue.prototype.storage.hostDownload = Vue.config.data.HOST_DONWLOAD
      Vue.prototype.storage.appConfig = Vue.config.data
    },
    getLimitByName(name) {
      var value = ('0' + Vue.prototype.storage.configuration.config[name]) * 1
      if (value === 0) {
        value = 5000
      }
      return value
    },
    host() {
      if (!window.HTTP_DIR) {
        return this.appConfig.HOST
      } else {
        return window.HTTP_DIR + '/peergroup/Site'
      }
    },
    shortHost() {
      if (!window.HTTP_DIR) {
        return this.appConfig.HOST
      } else {
        return window.HTTP_DIR
      }
    },
    removeState(fieldName) {
      if (fieldName) {
        fieldName = '' + this.getUserId() + '_' + fieldName
      }
      if (localStorage) {
        localStorage.removeItem(fieldName)
      }
    },

    getBranchList() {
      if (this.branchList === null) {
        this.branchList = Vue.prototype.storage.configuration.i18nBranches
      }
      //console.log('getBranchList', this.branchList)
      return this.branchList
    },
    getSourcesList() {
      let result = []
      var list = Vue.prototype.storage.configuration.i18nQuelle
      for (var index in list) {
        var item = list[index]
        if (item.lanId + '' === Vue.prototype.$api.getLanguage() + '') {
          result.push({
            title: '' + item.lanValue,
            id: '' + item.lanKey
          })
        }
      }
      console.log('quelle', result)
      return result
    },
    getSourcesListFiltered() {
      let result = []
      var list = Vue.prototype.storage.configuration.i18nQuelle
      for (var index in list) {
        var item = list[index]
        if (item.lanId + '' === Vue.prototype.$api.getLanguage() + '') {
          result.push({
            title: '' + item.lanValue,
            id: '' + item.lanKey
          })
        }
      }
      console.log('quelle filtered', result)
      return result
    },

    resetI18NState() {
      this.branchList = null
      this.sourceList = null
      this.countryList = null
      this.ratingKunde = null
      this.rating = null
      this.abschlussartList = null
      this.regionList = null
    },

    getRating() {
      if (this.rating === null) {
        var ratingList = Vue.prototype.storage.configuration.fieldsRating
        this.rating = []
        for (var index in ratingList) {
          var item = ratingList[index]
          this.rating.push({
            id: item,
            title: item,
            lanId: "1"
          })
        }
      }
      return this.rating
    },

    getRatingKunde() {
      if (this.ratingKunde === null) {
        var ratingListKunde = Vue.prototype.storage.configuration.fieldsRatingKunde
        this.ratingKunde = []
        for (var index in ratingListKunde) {
          var item = ratingListKunde[index]
          this.ratingKunde.push({
            id: item,
            title: item,
            lanId: "1"
          })
        }
      }
      return this.ratingKunde
    },

    getCountryList() {
      if (this.countryList === null) {
        var countryList = Vue.prototype.storage.configuration.countries
        this.countryList = []
        for (var index in countryList) {
          var item = countryList[index]
          if (item.lanId + '' === Vue.prototype.$api.getLanguage() + '') {
            this.countryList.push(item)
          }
        }
      }
      return this.countryList
    },
    getAbschlussartByNr(nr) {
      let list = Vue.prototype.storage.configuration.i18nAbschlussart
      let res = {}
      for (var index in list) {
        var item = list[index]
        var title = item.title
        if ((item.id + '') === ('' + nr) && (item.lanId + '' === Vue.prototype.$api.getLanguage() + '')) {
          res = item
        }
      }
      return res
    },
    getAbschlussartList() {
      if (this.abschlussartList === null) {
        this.abschlussartList = []
        let aart = Vue.prototype.storage.configuration.i18nAbschlussart
        for (var index in aart) {
          var item = aart[index]
          if (item.lanId + '' === Vue.prototype.$api.getLanguage() + '') {
            this.abschlussartList.push(item)
          }
        }
      }
      return this.abschlussartList
    },
    getRegionList() {
      if (this.regionList === null) {
        this.regionList = Vue.prototype.storage.configuration.regions
      }
      return this.regionList
    },
    getCurrencyList() {
      if (this.currencyList === null) {
        if (Vue.prototype.storage.configuration) {
          // this.currencyList = Vue.prototype.storage.configuration.i18nWaehrung
        }
      }
      return this.currencyList
    },
    /**
     *
     * @param butAddThisCurrency
     * @returns {[]|*[]}
     */
    getCurrencyListFiltered(butAddThisCurrency) {
      if (this.currencyList === null) {
        if (Vue.prototype.storage.configuration) {
          // this.currencyList = Vue.prototype.storage.configuration.i18nWaehrung
        }
      }
      var list = []
      for (var index in this.currencyList) {
        var item = this.currencyList[index]
        if ((item.display * 1 === 1) || (item.id * 1 === butAddThisCurrency * 1)) {
          list.push(item)
        }
      }

      function compare(a, b) {
        if (a.orderNr > b.orderNr) return 1;
        if (b.orderNr > a.orderNr) return -1;
        return 0;
      }

      list.sort(compare);
      return list
    },
    getCurrencyDimensionList() {
      var arr = []
      if (this.currencyDimensionList === null) {
        if (Vue.prototype.storage.configuration) {
          // this.currencyDimensionList = Vue.prototype.storage.configuration.waehrungsdimension
        }
      }
      if (!Vue.prototype.storage.configuration) {
        return this.currencyDimensionList
      }
      for (var rowIndex in Vue.prototype.storage.configuration.waehrungsdimension) {
        var item = Vue.prototype.storage.configuration.waehrungsdimension[rowIndex]
        if (item.lanId + '' === Vue.prototype.$api.getLanguage() + '') {
          arr.push(item)
        }
      }
      return arr
    },
    getRechtskreisByNr(nr) {
      let list = Vue.prototype.storage.configuration.rechtsKreise
      let res = {}
      for (var index in list) {
        var item = list[index]
        var title = item.title
        if ((item.id + '') === ('' + nr)) {
          res = item
        }
      }
      return res
    },
    getRechtskreise() {
      return Vue.prototype.storage.configuration.rechtsKreise
      /*
      if (this.rechtskreise === null) {
        var list = Vue.prototype.storage.configuration.rechtsKreise
        this.rechtskreise = []
        for (var index in list) {
          var item = list[index]
          var title = item.Rechtskreis
          for (var index2 in Vue.prototype.storage.configuration.i18nRechtskreis) {
            var i18n = Vue.prototype.storage.configuration.i18nRechtskreis[index2]
            if (i18n.id === item.RechtskreisNr) {
              title = i18n.title
            }
          }
          this.rechtskreise.push({
            title: '' + title,
            id: '' + item.RechtskreisNr
          })
        }
      }
      console.log('getRechtskreise', this.rechtskreise, Vue.prototype.storage.configuration.rechtsKreise)
      return this.rechtskreise
       */
    },
    saveState(fieldName, dataObject) {
      let jsonString = JSON.stringify(dataObject)
      if (fieldName) {
        fieldName = '' + this.getUserId() + '_' + fieldName
      }
      console.log('State save ' + fieldName, dataObject, jsonString)
      if (localStorage) {
        localStorage.setItem(fieldName, jsonString)
        // console.log('saveState', fieldName, jsonString, dataObject) // Vue.prototype.$api.getStackTrace()
      }
    },
    /**
     * Attentation this does not parse value from storage
     * @param fieldName
     * @param defValue
     * @returns {*}
     */
    getState(fieldName, defValue) {
      let res = this.getStorage(fieldName, defValue)
      // console.log('State load ' + fieldName, res)
      return res
    },
    getStorage(fieldName, defValue) {
      if (fieldName) {
        fieldName = '' + this.getUserId() + '_' + fieldName
      }
      var data = defValue
      if (localStorage) {
        data = localStorage.getItem(fieldName)
        if (!data) {
          data = defValue
        } else {
          try {
            data = JSON.parse(data)
          } catch (e) {
            data = defValue
          }

        }
      }
      // console.log('State load ' + fieldName, data)
      return data
    },
    clearState(fieldName) {
      if (fieldName) {
        fieldName = '' + this.getUserId() + '_' + fieldName
      }
      if (localStorage) {
        localStorage.setItem(fieldName, null)
        localStorage.removeItem(fieldName)
      }
      Vue.prototype.$api.debug('clearState', fieldName)
    }
  }
})
export default PGStorage



// WEBPACK FOOTER //
// ./src/storage.js